import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';

// import { FormattedMessage } from 'react-intl';

import MicromagSummary from '../summaries/MicromagSummary';
import DocumentFeaturedCard from './DocumentFeaturedCard';

import styles from '../../styles/cards/micromag-featured-card.module.css';

interface MicromagFeaturedCardProps extends Partial<DocumentSnippet> {
    className?: string | null;
    labelClassName?: string | null;
    imageContainerClassName?: string | null;
}
function MicromagFeaturedCard({
    slug = null,
    className = null,
    labelClassName = null,
    imageContainerClassName = null,
    title = null,
    subtitle = null,
    ...props
}: MicromagFeaturedCardProps) {
    const url = useUrlGenerator();
    return (
        <DocumentFeaturedCard
            {...props}
            withCoverImage
            slug={slug}
            title={title}
            className={classNames(styles.container, className)}
            labelClassName={classNames(styles.label, labelClassName)}
            imageContainerClassName={classNames(styles.imageContainer, imageContainerClassName)}
            label={
                <MicromagSummary
                    link={
                        slug !== null
                            ? url('micromag', {
                                  slug,
                              })
                            : null
                    }
                    title={title}
                    source="micromag_featured"
                    description={subtitle}
                    className={styles.summary}
                    titleClassName={styles.summaryTitle}
                    descriptionClassName={styles.summaryDescription}
                    buttonClassName={styles.summaryButton}
                />
            }
        />
    );
}
export default MicromagFeaturedCard;
